<div class="grid-filter-boolean">
    <kendo-dropdownlist [data]="data" [popupSettings]="{ width: 'auto' }" (valueChange)="onChange($event)"
        [(value)]="selectedValue">
    </kendo-dropdownlist>
</div>
<button *ngIf="hasFilters" kendoButton class="k-button k-button-icon k-clear-button-visible" [icon]="'filter-clear'" (click)="clearFilter()"></button>